import { Reset } from "@/modules/auth/common/enum";
import { ACCOUNT_FORMAT } from "@/shared/common/constants";
import { isAllowedAccountNumberTyping } from "@/shared/helpers";
import { useAppSelector } from "@/shared/hooks";
import { FormField } from "@ab.uitools/ui-library/components/FormField";
import { Input } from "@ab.uitools/ui-library/components/Input";
import { useFormProps } from "@ab.uitools/ui-library/hooks/useFormProps";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export const AccountNumberFormFields = () => {
  const { t } = useTranslation();
  const { setValue, reset, isSubmitted } = useFormProps();

  const resetFields = useAppSelector((state) => state.auth.reset);

  useEffect(() => {
    if (resetFields.accountNumber) {
      reset?.({ [Reset.AccountNumber]: "" });
      setValue(Reset.AccountNumber, resetFields.accountNumber);
    }
  }, [resetFields]);

  return (
    <FormField
      name={Reset.AccountNumber}
      className="mt-24"
      errorMessageIcon="infoFilled"
      hideErrorMessage={!isSubmitted}
      As={(props) => {
        const customProps = {
          ...props,
          hasError: isSubmitted && props.hasError,
        };
        return (
          <Input
            {...customProps}
            required
            type="numeric"
            maxCount={16}
            className="mt-24"
            placeholder={ACCOUNT_FORMAT}
            pattern="[0-9]*"
            inputMode="numeric"
            label={t("auth.accountOrCardVerification.anyAccount")}
            isAllowed={({ formattedValue }) => isAllowedAccountNumberTyping(formattedValue)}
          />
        );
      }}
    />
  );
};
